import {Form} from "antd";
import DG_Form from "../../../custom/data-entry/form";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Content from "./content";
import {mapDatasource} from "./mapDatasource";
import {addCustomer} from "../../../api/customer";
import {onChangeVisibleDrawerAdmin, onReloadData} from "../../../redux/actions/layout/interaction/action";
import uuid from "react-uuid";
import {DG_Format_Status} from "../../../format/Status";

const Add = ({onLoading, list}) => {

    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [form] = Form.useForm()
    const key = uuid()
    const [datasource, setDatasource] = useState([])
    const onFinish = (value) => {
        value = {
            ...value,
            list: mapDatasource(datasource)
        }
        onLoading(true)
        addCustomer(value).then(r => {
            dispatch(onChangeVisibleDrawerAdmin(undefined))
            dispatch(onReloadData(!reloadData))
            onLoading(false)
        })
            .catch(ex => {
                onLoading(false)
            })
    }

    useEffect(() => {
        form.setFieldsValue({key: key})
    }, [])

    const mapDatasourceList = (data)=>{
        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                ...item,
                statusFormat: DG_Format_Status(item.status)
            };
        });
    }

    return (
        <>
            <DG_Form
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >
                <Content list={list}
                         form={form}
                         datasource={datasource}
                         onDatasource={(value) => {
                             setDatasource(mapDatasourceList(datasource.concat(value)))
                         }}/>

            </DG_Form>
        </>
    )
}

export default Add
